import React, { useState } from 'react'
import { Row, Col, Typography, Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import styles from '../Organizations.module.less'
import { RolesCard } from './RolesCard'
import { PermissionGroupsTable } from './PermissionGroupsTable'

export const RoleManagement = () => {
  const { t } = useTranslation()
  const [searchKeyword, setSearchKeyword] = useState('')

  const handleSearch = (value: string) => {
    setSearchKeyword(value)
  }

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      setSearchKeyword('')
    }
  }

  return (
    <div className={styles.OrganizationStaffs}>
      <Row align="middle" justify="space-between" style={{ marginBottom: 30 }}>
        <Col>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {t('roleManagement.roleManagement')}
          </Typography.Title>
        </Col>
        <Col>
          <Input
            style={{ width: 250 }}
            prefix={<SearchOutlined />}
            placeholder={t('search')}
            onPressEnter={e => handleSearch(e.currentTarget.value)}
            onChange={handleSearchChange}
            allowClear
          />
        </Col>
      </Row>
      <div className={styles.ContentBox}>
        <div className={styles.Container}>
          <div className={styles.LeftPanel}>
            <RolesCard />
          </div>
          <div className={styles.RightPanel}>
            <PermissionGroupsTable searchKeyword={searchKeyword} />
          </div>
        </div>
      </div>
    </div>
  )
}
